const mediaTagsDefaultState = {
  data: {},
  loading: false,
  error: false,
  success: false,
  successMessage: '',
  errorMessage: null,
};

const mediaTagsReducer = (state = mediaTagsDefaultState, action) => {
  switch(action.type) {
    case 'START_GET_MEDIA_TAGS':
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'GET_MEDIA_TAGS_SUCCESS':
      return {
        ...state,
        data: action.mediaTags,
        loading: false,
        error: false,
        errorMessage: null,
      };
    case 'START_CREATE_MEDIA_TAGS':
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'CREATE_MEDIA_TAGS_SUCCESS':
      return {
        ...state,
        data: action.mediaTag,
        loading: false,
        success: true,
        error: false,
        errorMessage: null,
        successMessage: 'Your account has been created!',
      };
    case 'START_UPDATE_MEDIA_TAGS':
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'UPDATE_MEDIA_TAGS_SUCCESS':
      return {
        ...state,
        data: {
          ...state.data,
          ...action.mediaTag
        },
        loading: false,
        success: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'SHOW_ERROR':
      return {
        ...state,
        loading: false,
        error: true,
        successMessage: '',
        errorMessage: action.errorMessage
      };
    default:
      return state;
  }
};

export default mediaTagsReducer;
